<template>
  <el-dialog
    title="设置建议评估等级"
    :visible.sync="setLevel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="650px"
    center>
    <el-radio-group v-model="levels">
      <el-radio :label="5" border >5A级</el-radio>
      <el-radio :label="4" border >4A级</el-radio>
      <el-radio :label="3" border >3A级</el-radio>
      <el-radio :label="2" border >2A级</el-radio>
      <el-radio :label="1" border >1A级</el-radio>
    </el-radio-group>

    <div class="flex align-center justify-around margin-top">
      <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
      <el-button class="padding-lr-xl" type="primary" @click="submitForm()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>



import {saveTotalLevel} from "@/api/admin";

export default {
  name: "setLevel",
  props: {
    setLevel: {
      type: Boolean,
    },
    level: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  data() {
    return {
      levels:''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },

  },
  created() {
    this.levels = this.level?this.level:''
  },
  methods: {
    resetForm() {
      this.$emit('cancelDialog', false)
    },
    async submitForm(){
      if(!this.levels) return this.$message.error('请设置建议评估等级')
      const res = await saveTotalLevel(this.$route.params.id,this.$route.params.sid,this.levels)
      if(res.status === 200){
        this.$message.success('设置成功')
        this.$emit('cancelDialog', true)
      }
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">

</style>
